import {
  DollarIcon,
  RupiahIcon,
} from '../../assets/icons';

// COUNTRY
export const COUNTRY_MY = 'my';
export const COUNTRY_ID = 'id';
export const COUNTRY_VN = 'vn';

export const COUNTRIES = Object.freeze({
  [COUNTRY_MY]: {
    ic_field: 'nric',
    ic_validation_regex: /^[0-9]{12}$/,
    tax_id_regex: '^[^\\s]*$',
    currency: 'MYR',
    currency_icon: DollarIcon,
    locale_code: 'en-MY',
    timezone: 'Asia/Kuala_Lumpur',
  },
  [COUNTRY_ID]: {
    ic_field: 'ktp',
    ic_validation_regex: /^[0-9]{16}$/,
    tax_id_regex: '^(?:\\d{16}|\\d{2}\\.\\d{3}\\.\\d{3}\\.\\d-\\d{3}\\.\\d{3})$',
    currency: 'Rp',
    currency_icon: RupiahIcon,
    locale_code: 'id-ID',
    timezone: 'Asia/Jakarta',
  },
  [COUNTRY_VN]: {
    ic_field: 'cccd',
    ic_validation_regex: /^[0-9]{12}$/,
    mobile_regex: '^0?[35789]\\d{8}$',
    tax_id_regex: '^(?:\\d{10}|\\d{10}-\\d{3})$',
    currency: 'đ',
    // currency_icon: Icon,
    locale_code: 'vi-VN',
    timezone: 'Asia/Ho_Chi_Minh',
  },
});
export const COUNTRY_CODES = Object.freeze(Object.keys(COUNTRIES));

// APP
export const APP_SHOWROOM = 'showroom';
export const APP_LOAN_TRACKER = 'loan_tracker';
export const APP_CRM = 'crm';
export const APP_CREDIT_CONTROL = 'credit_control';
export const APP_ANALYTICS = 'analytics';
export const APP_COMMISSION_TRACKER = 'commission_tracker';

export const APPS = Object.freeze([
  APP_SHOWROOM,
  APP_LOAN_TRACKER,
  APP_CRM,
  APP_CREDIT_CONTROL,
  APP_ANALYTICS,
  APP_COMMISSION_TRACKER,
]);

export const countryICField = (countryCode) => {
  const country = COUNTRIES[countryCode];
  if (country) {
    return country.ic_field;
  }
  return COUNTRIES[COUNTRY_MY].ic_field;
};

export const countryCurrency = (countryCode) => {
  const country = COUNTRIES[countryCode];
  if (country) {
    return country.currency;
  }
  return COUNTRIES[COUNTRY_MY].currency;
};

export const countryCurrencyIcon = (countryCode) => {
  const country = COUNTRIES[countryCode];
  if (country && country.currency_icon) {
    return country.currency_icon;
  }
  return COUNTRIES[COUNTRY_MY].currency_icon;
};
